import React from 'react';
import { css } from '@emotion/react';
import { Button } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { RecordLink } from './DownstreamRecords';

// `error` is the last revert response's message; it covers failures on other invoices in the group.
const RevertIncompleteBanner = ({ invoice, error, onRetry }) => {
    const failed = (invoice?.accounting_records || []).filter((r) => r.status === 'REVERT_FAILED' && r.error);
    return (
        <MuiAlert
            severity="error"
            css={css`
                margin: 12px 0;
            `}
            action={
                <Button color="inherit" size="small" onClick={onRetry}>
                    Retry revert
                </Button>
            }
        >
            Revert incomplete. Nothing was released; fix or retry the records below.
            {error && <div>{error}</div>}
            {failed.map((r) => (
                <div key={r.id}>
                    {r.error} (<RecordLink record={r} invoiceType={invoice.type} />)
                </div>
            ))}
        </MuiAlert>
    );
};

export default RevertIncompleteBanner;
